import { commaSeparated } from '@calculations/utilities/currency';
import { Text } from '@react-pdf/renderer';

type EstimatedQuantityOnHandProps = {
  qtyOnHand?: number | null;
};

export function EstimatedQuantityOnHand({
  qtyOnHand,
}: EstimatedQuantityOnHandProps) {
  if (qtyOnHand === undefined || qtyOnHand === null) {
    return null;
  }

  return <Text>Estimated Quantity On Hand: {commaSeparated(qtyOnHand)}</Text>;
}
